const L10N_DIRECTORY = 'resources/lang';
const LANG_PROPERTIES = { en_US: 'en' };

class TranslateService {
    constructor($http, $q, $log, config) {
        this.$http = $http;
        this.config = config;
        this.$q = $q;
        this.mainTranslationObject = { en_US: null, ja_JP: null };

        // this.translations = {};
        // const requests = config.langFiles
        //     .map(this.fullPath.bind(this))
        //     .map(fileName => $http.get(fileName).catch(err => $log.warn(`(L10n) Error loading ${fileName}`, err)));

        // this.translationsPromise = $q
        //     .all(requests)
        //     .then(responses => responses.forEach(response => response && this.processResponse(response.data)));
    }

    loadData(lang) {
        if (!!this.translationsPromise && (!lang || this.config.locale.toLowerCase() === lang.toLowerCase())) return this.$q(resolve => resolve(true));
        if (lang) this.config.locale = lang.toLowerCase();
        this.defaultLangInUse = this.config.locale === LANG_PROPERTIES.en_US;
        let temp = (new Date()).getTime(),
            tempRequestsList = [];

        // DEFAULT LANG (EN) MUST BE LOADED
        if (!this.mainTranslationObject.en_US || _.isEmpty(this.mainTranslationObject.en_US)) {
            this.mainTranslationObject.en_US = {};
            const requestsEn = this.config.langFiles
                .map(item => this.fullPath(item, LANG_PROPERTIES.en_US))
                .map(fileName => this.getTranslation(fileName, temp, 'en_US', LANG_PROPERTIES.en_US));
            requestsEn.forEach(item => tempRequestsList.push(item));
        }

        // LOAD OTHER LANGUAGE IF NEEDED
        let otherKey = null;
        if (lang && lang.toLowerCase() !== LANG_PROPERTIES.en_US) {
            Object.keys(LANG_PROPERTIES).forEach(key => {
                if (lang.toLowerCase() === LANG_PROPERTIES[key]) otherKey = key;
            });
            if (otherKey && (!this.mainTranslationObject[otherKey] || _.isEmpty(this.mainTranslationObject[otherKey]))) {
                this.mainTranslationObject[otherKey] = {};
                const requestsJp = this.config.langFiles
                    .map(item => this.fullPath(item, LANG_PROPERTIES[otherKey]))
                    .map(fileName => this.getTranslation(fileName, temp, otherKey, LANG_PROPERTIES[otherKey]));
                requestsJp.forEach(item => tempRequestsList.push(item));
            }
        }

        // IF ALL LOCALIZATION FILES ARE ALREADY LOADED JUST RESET TRANSLATION FILE
        if (!tempRequestsList.length) {
            this.setActiveTranslation(otherKey);
            return this.$q(resolve => resolve(true));
        }
        // ELSE LOAD NEEDED LOCALIZATION FILES
        return this.translationsPromise = this.$q
            .all(tempRequestsList)
            .then(responses => {
                responses.forEach(response => response && response.data && this.processResponse(response.data, response.langKey));
                this.setActiveTranslation(otherKey);
                return this.translations;
            });
    }

    getTranslation(fileName, temp, langKey, langValue) {
        return this.$http.get(fileName + '?t=' + temp).then((response) => {
            return { data: response.data, name: fileName, lang: langValue, langKey: langKey };
        }).catch(err => this.$log.warn(`(L10n) Error loading ${fileName}`, err))
    }

    setActiveTranslation(otherKey) {
        // USE EN LANG AS DEFAULT IF ADDITIONAL LANG IS NOT SET
        this.translations = otherKey && this.mainTranslationObject[otherKey] && !_.isEmpty(this.mainTranslationObject[otherKey])
            ? this.mainTranslationObject[otherKey] : this.mainTranslationObject.en_US;
    }

    fullPath(langFile, lang) {
        // return `${L10N_DIRECTORY}/${langFile}_${this.config.locale}.properties`;
        return `${L10N_DIRECTORY}/${langFile}_${lang.toLowerCase()}.json`;

    }

    // processResponse(responseData) {
    //     responseData
    //         .split('\r\n')
    //         .join('\n')
    //         .split('\n')
    //         .filter(line => line)
    //         .forEach(line => {
    //             let index = line.indexOf('=');
    //             index > 0 && (this.translations[line.substring(0, index)] = line.substring(index + 1));
    //         });
    // }
    processResponse(responseData, langKey) {
        Object.keys(responseData).forEach(key => {
            this.mainTranslationObject[langKey][key] = responseData[key];
        });
    }

    translate(key, args) {
        let result = this.translations[key];
        if (!result) {
            return `!!! ${key} !!!`;
        }

        for (let propName in args) {
            result = result.split(`%${propName}%`).join(args[propName] || `!!! ${propName} !!!`);         //.json files

            // result = result.split(`\\%${propName}\\%`).join(args[propName] || `!!! ${propName} !!!`);
        }
        return result;
    }
}

TranslateService.$inject = ['$http', '$q', '$log', 'config'];

module.exports = TranslateService;



// WEBPACK FOOTER //
// ./src/shared/utils/translate.service.js